var map = {
	"./010493tigersky.jpg": 187,
	"./011062rhino.jpg": 188,
	"./030914bhimsenjoshi.jpg": 189,
	"./031117biryani.jpg": 190,
	"./031117motichurladdoo.jpg": 191,
	"./040916saintteresacanonization.jpg": 192,
	"./050517trai.jpg": 193,
	"./051216bluethroatedmacaw.jpg": 194,
	"./070165tata.jpg": 195,
	"./071063gaur.jpg": 196,
	"./081296saarc.jpg": 197,
	"./0908171942freedommovement08.jpg": 198,
	"./110587jkrishnamurti.jpg": 199,
	"./111166azad.jpg": 200,
	"./130211savithri.jpg": 201,
	"./130386cmahaprabhu.jpg": 202,
	"./140862bombayhighcourt.jpg": 203,
	"./1964childrensday.jpg": 204,
	"./1973childrensday.jpg": 205,
	"./1977childrensday2.jpg": 206,
	"./1978childrensday.jpg": 207,
	"./210917diwali02.jpg": 208,
	"./250317car3.jpg": 209,
	"./60pgandhidefinitive.jpg": 210,
	"./sachin141113b.jpg": 211,
	"./svrangarao030513.jpg": 212,
	"./telugu120475.jpg": 213
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 186;